module.exports = __webpack_public_path__ + "static/media/capsule-drugs-medical-svgrepo-com.d1b972bb.svg";